import React from 'react';
import styled, { keyframes } from 'styled-components';

const rotate = keyframes`
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
`;

const Svg = styled.svg`
  display: block;
  animation: ${rotate} 0.9s linear infinite;
  transform-origin: 50% 50%;
  backface-visibility: hidden;

  circle.track {
    opacity: 0.18;
  }

  circle.arc {
    stroke-linecap: round;
  }

  @media (prefers-reduced-motion: reduce) {
    animation-duration: 3s;
  }
`;

const CustomSpin = ({ size = 26, color = '#8e9aa6', thickness = 3 }) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 50 50"
    role="status"
    aria-label="loading"
  >
    {/* حلقه‌ی کم‌رنگ پشت */}
    <circle
      className="track"
      cx="25"
      cy="25"
      r="20"
      fill="none"
      stroke={color}
      strokeWidth={thickness}
    />

    {/* آرک ثابت (حدود ۷۰٪ دایره) که فقط می‌چرخد */}
    <circle
      className="arc"
      cx="25"
      cy="25"
      r="20"
      fill="none"
      stroke={color}
      strokeWidth={thickness}
      strokeDasharray="60 126"
    />
  </Svg>
);

export default CustomSpin;